var map = {
	"./bnb.png": 5146,
	"./cpt.png": 6176,
	"./nova.png": 2532,
	"./novamining.png": 9712,
	"./ton.png": 5143,
	"./tonGray.png": 7818,
	"./usd1.png": 4931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5925;